import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { addPaymentBreadcrumb, setPaymentContext } from '@/lib/sentry'

import { FailureView, KeyFlow, SuccessView, UnknownView } from './components'
import { parseEntryContext } from './lib/parseEntryContext'

/**
 * PG 결제 후 결과 화면 (방식 B).
 *
 *  - `?key=` (토스/네이버 success) → KeyFlow: GET /product-payments/process/{key} → 콜백 → 완료
 *  - `?paymentId=` (카카오 success) → 완료 화면 (백엔드 S2S 콜백으로 확정, webview 는 pg_token 불필요)
 *  - `?resultCode=` Success 아님 (네이버 실패) → 실패 화면
 *  - `?code=&message=` (토스 fail — 이번 phase 미사용 분기) → 실패 화면
 *  - 그 외 → 에러 화면
 */
export default function SealedVinylResultPage() {
  const [searchParams] = useSearchParams()
  const context = parseEntryContext(searchParams)

  useEffect(() => {
    setPaymentContext({ step: 'result' })
    addPaymentBreadcrumb('결과 진입', { result: context.kind })
  }, [context.kind])

  if (context.kind === 'key') return <KeyFlow processKey={context.key} />
  if (context.kind === 'kakao') return <SuccessView />
  if (context.kind === 'naverFail' || context.kind === 'tossFail') return <FailureView />
  return <UnknownView />
}
